import {
  AdvertiserGroupDto,
  AdvertiserSummaryProjectionDto,
  CognitoUserDto,
  PagedModelStandardUserOutputDto,
  PagedModelInternalUserOutputDto,
  StandardUserOutputDto,
  StandardUserOutputDtoRoleEnum,
  UserWithMetadataDto,
} from '@kortxio/hub-api';
import { RequestState } from 'features/shared/request';

export type StandardUserAsRow = {
  id?: string;
  username?: string;
  lastName?: string;
  firstName?: string;
  fullName?: string;
  email?: string;
  role: StandardUserOutputDtoRoleEnum;
  clientId?: number;
  advertiserIds?: number[];
  advertiserNames?: string[];
  advertiserGroupNames?: string[];
  enabled: boolean;
  createdAt?: string;
  updatedAt?: string;
};

export const dtoToStandardUserAsRow = (
  dto: StandardUserOutputDto,
  advertisers: AdvertiserSummaryProjectionDto[] | undefined,
  advertiserGroups: AdvertiserGroupDto[] | undefined
): StandardUserAsRow => {
  return {
    id: dto.id,
    username: dto.username,
    lastName: dto.lastName,
    firstName: dto.firstName,
    fullName: `${dto.firstName} ${dto.lastName}`,
    email: dto.email,
    role: dto.role as StandardUserOutputDtoRoleEnum, // If we have an undefined role here it means the server is broken.
    clientId: dto.clientId,
    advertiserIds: dto.advertiserIds,
    advertiserNames:
      advertisers && dto.advertiserIds
        ? (
            dto.advertiserIds
              .map((id) => {
                const advertiser = advertisers.find((value) => value.id === id);

                return advertiser?.name ?? undefined;
              })
              .filter((value) => value !== undefined) as string[]
          ).sort((a, b) => a.localeCompare(b))
        : [],
    advertiserGroupNames:
      advertiserGroups && dto.advertiserGroupIds
        ? (
            dto.advertiserGroupIds
              .map((id) => {
                const advertiserGroup = advertiserGroups.find(
                  (value) => value.id === id
                );

                return advertiserGroup?.name ?? undefined;
              })
              .filter((value) => value !== undefined) as string[]
          ).sort((a, b) => a.localeCompare(b))
        : [],
    enabled: dto.enabled ?? false,
    createdAt: dto.createdAt,
    updatedAt: dto.updatedAt,
  };
};
export type DialogState = {
  isOpen: boolean;
};

export type StandardUserDialogState = DialogState & {
  user: StandardUserOutputDto | undefined;
};

export type StandardUserUiState = {
  search: string | undefined;
  isShowDisabledChecked: boolean;
  createDialog: DialogState;
  updateDialog: StandardUserDialogState;
  manageNotificationsDialog: StandardUserDialogState;
  disableDialog: StandardUserDialogState;
  enableDialog: StandardUserDialogState;
  resetPasswordDialog: StandardUserDialogState;
};

export type UserUiState = {
  updateAccountConfirmationDialog: DialogState;
  changePasswordConfirmationDialog: DialogState;
  standardUser: StandardUserUiState;
};

export type UserState = {
  cognitoUser: {
    data: CognitoUserDto | undefined;
    request: RequestState;
  };
  user: {
    data: UserWithMetadataDto | undefined;
    request: RequestState;
  };
  magicBellHmac: {
    data: string | undefined;
    request: RequestState;
  };
  standardUsers: {
    data: PagedModelStandardUserOutputDto | undefined;
    request: RequestState;
  };
  internalUsers: {
    data: PagedModelInternalUserOutputDto | undefined;
    request: RequestState;
  };
  ui: UserUiState;
};
